import { render } from "./MedicalPaidBills.vue?vue&type=template&id=c63639c6"
import script from "./MedicalPaidBills.vue?vue&type=script&lang=js"
export * from "./MedicalPaidBills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__